import { createSelector } from '@reduxjs/toolkit';

import { selectExternalTourBannerImageUrl } from './selectExternalTourBannerImageUrl';
import { selectNewbuildingTourBannerImageUrl } from './selectNewbuildingTourBannerImageUrl';
import { isNewbuildingSelector, selectOfferPhotos } from '../offer';

export const selectTourBannerImageUrl = createSelector(
  selectNewbuildingTourBannerImageUrl,
  selectExternalTourBannerImageUrl,
  selectOfferPhotos,
  isNewbuildingSelector,
  (tourBannerImageUrlV2, externalUrl, offerPhotos, isNewbuilding) => {
    const defaultImage = tourBannerImageUrlV2 || externalUrl;

    if (isNewbuilding) {
      return defaultImage;
    }

    const mainPhoto = offerPhotos?.find(photo => photo.isDefault) || offerPhotos?.[0];

    return mainPhoto?.fullUrl || defaultImage;
  },
);
